import React, { useEffect, useState } from "react";
import {
  MDBCard,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
} from "mdb-react-ui-kit";
import Skeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import Alert from "@mui/material/Alert";
import RateIcon from "../../Dashbord/rate-icon/RateIcon";
// img
import Delete from "../../../images/business dashboard/reply.png";
import picComments from "../../../images/end user/comments.png";
import userIcon from "../../../images/register-business/user.png";

const CommentBusiness = (props) => {
  const { datacome2 } = props;

  const [data, setdata] = useState([]);
  // states for modal
  const [centredModal, setCentredModal] = useState(false);
  const toggleShow = () => setCentredModal(!centredModal);
  const [idDelete, setIdDelete] = useState(null);
  const [modalData, setModalData] = useState({});
  const [showAlert, setshowAlert] = useState(false);

  const setIDforDelete = (idDelete, item) => {
    setIdDelete(idDelete);
    setModalData(item);
  };
  const deleteHandeler = () => {
    setdata(data.filter((item) => item.id !== idDelete));
  };

  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      setshowAlert(false);
    }, 5000);
  };

  useEffect(() => {
    setdata(props.dataCom);
  }, [props.dataCom]);

  return (
    <>
      <div className="costum_option_center t--0">
        {data.length > 0 ? (
          data.map((item) => (
            <div
              key={item.commentTitle}
              onClick={() => {
                // toggleShow();
                // setIDforDelete(item.id, item);
              }}
            >
              <MDBCard
                className="color-101010 px-auto card-border body-comment-business d-block"
                style={{ maxWidth: "" }}
              >
                <div className="p-2">
                  <div className="d-flex">
                    <div className="text-align-last-center">
                      {datacome2 ? (
                        <MDBCardImage
                          className="img-comment-business"
                          src={item.photoPath ? item.photoPath : userIcon}
                          alt="...."
                          fluid
                        />
                      ) : (
                        <Skeleton
                          variant="rectangular"
                          className=" img-comment-business"
                          animation="wave"
                        />
                      )}
                      {/* <div className="mask dash-img-mask"></div> */}
                    </div>
                    <div className="fw-bold fs-15 mb-1 fs-xs-15 f14 pt-1">
                      {datacome2 ? (
                        <>
                          <span className="first-title-profile fw-bold d-block title-option-res mb-1">
                            {item.commentTitle}
                          </span>{" "}
                          <span className="first-title-profile fw-bold first-title-profile2 fs-16-pro">
                            {item.rateTitle}
                          </span>
                          <RateIcon
                            className="ml20"
                            cardrate={parseFloat(item.rate)}
                            isRec={1}
                            isAdd={0}
                            dir="ltr "
                          />
                        </>
                      ) : (
                        <>
                          <Skeleton
                            className="ms-1"
                            width={50}
                            height={16}
                            animation="wave"
                          />
                          <Skeleton
                            className=""
                            width={100}
                            height={28}
                            animation="wave"
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="w-100">
                    <MDBCardBody className="me-md-2 mt-2 pt-md-0 pt-1 p-0 px-2 px-md-0">
                      <MDBCardText className=" fs-13 fs-xs-13 color-67808f f12">
                        <div className="first-title-profile">
                          {datacome2 ? (
                            <p className=" mb-1">{item.commentBody}</p>
                          ) : (
                            <>
                              <Skeleton
                                className="d-block w-100"
                                variant="text"
                                sx={{ fontSize: "0.6rem" }}
                                animation="wave"
                              />
                              <Skeleton
                                className="d-block w-100 mb-2"
                                variant="text"
                                sx={{ fontSize: "0.6rem" }}
                                animation="wave"
                              />
                            </>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <div className="">
                            {datacome2 ? (
                              <>
                                <small className="time-title-profile  d-md-block mb-0">
                                  نوشته شده توسط {item.fullName} در تاریخ{" "}
                                  {item.commentDate}
                                </small>
                                {!item.approved && (
                                  <small className="d-block mt-2 fs-10 color-67808f">
                                    این دیدگاه در انتظار تایید توسط ادمین، برای
                                    نمایش در وبسایت میباشد.
                                  </small>
                                )}
                              </>
                            ) : (
                              <Skeleton
                                className="d-block w-100 mb-2"
                                variant="text"
                                sx={{
                                  fontSize: "0.6rem",
                                  width: "80px !important",
                                }}
                                animation="wave"
                              />
                            )}
                          </div>
                          {/* comment this part for now */}
                          {/* <div className="text-start h-192">
                            {datacome2 ? (
                              <span className="proofile_tooltip proofile_tooltip2">
                                <a
                                  onClick={() => {
                                    // toggleShow();
                                    // setIDforDelete(item.id, item);
                                    // setCentredModal(false);
                                  }}
                                  // href="https://new.gishniz.com/business#comments"
                                >
                                  <img
                                    src={Delete}
                                    alt="..."
                                    className="img_delete mr10 ms-0  ms-md-2 "
                                  />
                                </a>
                                <span className="tooltiptext_option tooltiptext_option_dash_bus f12">
                                  پاسخ دادن
                                </span>
                              </span>
                            ) : (
                              // <span className="proofile_tooltip ms-3">
                              <Skeleton
                                variant="circular"
                                width={22}
                                height={22}
                                animation="wave"
                                className=" ms-md-4 float-start"
                              >
                                <Avatar animation="wave" />
                              </Skeleton>
                              // </span>
                            )}
                          </div> */}
                        </div>
                      </MDBCardText>
                    </MDBCardBody>
                  </div>
                </div>
              </MDBCard>
            </div>
          ))
        ) : (
          <>
            <div className="d-flex justify-content-center align-items-center mt-150">
              <img
                src={picComments}
                alt="no comments"
                className="img_no_comments"
              />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <p className="text_no_image mb-2">دیدگاه جدیدی ثبت نشده</p>
            </div>
          </>
        )}
        {/* modal delete */}

        <MDBModal
          tabIndex="-1"
          show={centredModal}
          setShow={setCentredModal}
          id={idDelete}
        >
          <div className="d-flex align-items-center whole-modal ">
            <div className="side-modal d-md-block d-none"></div>
            <MDBModalDialog
              centered
              className="justify-content-center body-comment-business-dialog"
            >
              <MDBModalContent className="costum_modal-comment-business ">
                <div className="reletive_profile">
                  <MDBBtn
                    className="btn-close close_modal"
                    color="none"
                    onClick={toggleShow}
                  ></MDBBtn>
                </div>
                {/* <MDBCard
                className="color-101010 px-auto card-border body-comment-business d-block"
                style={{ maxWidth: "" }}
              > */}
                <MDBRow className="g-0">
                  <MDBCol className="col-12 col-md-1 col-md-1 col-lg-1 text-align-last-center">
                    <MDBCardImage
                      className="img-comment-business"
                      src={modalData.photoPath ? modalData.photoPath : userIcon}
                      alt="...."
                      fluid
                    />
                    {/* <div className="mask dash-img-mask"></div> */}
                  </MDBCol>
                  <MDBCol className="col-12 col-md-8 col-md-11 col-lg-11 ">
                    <MDBCardBody className="me-md-2 mt-2 pt-md-0 pt-1 p-0 px-md-4 px-md-0">
                      <MDBCardTitle className="fw-bold fs-15 mb-1 fs-xs-15 f14 ">
                        <MDBRow>
                          <MDBCol className="col-md-6 col-12 ">
                            <span className="first-title-profile fw-bold d-block title-option-res">
                              {modalData.commentTitle}
                            </span>
                            <div className="text-start mb-1 ms-2 d-md-none">
                              <span className="first-title-profile fw-bold first-title-profile2 fs-16-pro">
                                {modalData.rateTitle}
                              </span>
                              <RateIcon
                                className="ml20"
                                cardrate={parseFloat(modalData.rate)}
                                isRec={1}
                                isAdd={0}
                                dir="ltr "
                              />
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBCardTitle>
                      <MDBCardText className=" mb-md-2 mb-0 fs-14 fs-xs-14 f12 d-none d-md-block">
                        <MDBRow className="mt-2">
                          <MDBCol className="col-md-6 col-12 text-end d-flex align-items-center">
                            <span className="first-title-profile fw-bold first-title-profile2 fs-16-pro">
                              {modalData.rateTitle}
                            </span>
                            <RateIcon
                              className="ml20"
                              cardrate={parseFloat(modalData.rate)}
                              isRec={1}
                              isAdd={0}
                              dir="ltr "
                            />
                          </MDBCol>
                        </MDBRow>
                      </MDBCardText>
                      <MDBCardText className="pt-md-1 pt-2 fs-13 fs-xs-13 color-101010ab f12">
                        <div className="d-flex first-title-profile">
                          <p
                            className=" mb-1 
                          "
                          >
                            {modalData.commentBody}
                          </p>
                        </div>
                        <MDBRow className="align-items-end">
                          <MDBCol className="col-md-6 col-10">
                            <small className="time-title-profile  d-md-block mb-0">
                              {modalData.fullName} {modalData.commentDate}
                            </small>
                          </MDBCol>
                          <MDBCol className="col-md-6 col-2 text-start h-192">
                            <span className="proofile_tooltip proofile_tooltip2">
                              <a
                                onClick={() => {
                                  // toggleShow();
                                  // setIDforDelete(item.id, item);
                                  // setCentredModal(false);
                                }}
                                // href="https://new.gishniz.com/business#comments"
                              >
                                <img
                                  src={Delete}
                                  alt="..."
                                  className="img_delete mr10 ms-0 ms-md-2 "
                                />
                              </a>
                              <span className="tooltiptext_option tooltiptext_option_dash_bus f12">
                                پاسخ دادن
                              </span>
                            </span>
                          </MDBCol>
                        </MDBRow>
                      </MDBCardText>
                      <MDBCardText className=""></MDBCardText>
                    </MDBCardBody>
                  </MDBCol>
                </MDBRow>
                {/* {console.log(modalData)} */}
                {/* </MDBCard> */}
                {/* <div>
                <p className="text_modal px-3">
                  آیا می‌خواهید این دیدگاه از لیست دیدگاه‌‌هایتان پاک شود؟
              
                </p>
              </div> */}
                {/* <div className="a_s_c">
                <button
                  onClick={() => {
                    toggleShow();
                    deleteHandeler();
                    alertHandeler();
                  }}
                  className="button_modal"
                >
                  حذف شود
                </button> */}
                {/* </div> */}
              </MDBModalContent>
            </MDBModalDialog>
          </div>
        </MDBModal>
      </div>

      {/* alert delete */}
      {/* {showAlert ? (
        <div className={"succsess_delete"}>
          <Alert
            severity="success"
            icon={false}
            className={"alert_succsess_delete"}
          >
            <p className="text_alert_delete">
              این دیدگاه از لیست دیدگاه‌‌هایتان حذف شد.
            </p>
          </Alert>
        </div>
      ) : (
        ""
      )} */}
    </>
  );
};

export default CommentBusiness;
